import { useLocation } from 'react-router-dom';

import { SiteInfoResponseModelV2 } from '@newfold/huapi-js/src/index.schemas';

import { getAiProductAMRedirectUrl } from '~/components/TenantProvider/utils/tenantHelpers';
import useAccount from '~/hooks/useAccount';
import { useBrandInfo } from '~/hooks/useBrandInfo';
import { useSiteContext } from '~/scenes/Site';
import { checkWordPressType, isAiSite } from '~/utils/site/helpers';

const useAMDomainFlow = (siteInfoOverride?: SiteInfoResponseModelV2) => {
  const { pathname } = useLocation();
  const siteContext = useSiteContext();
  const siteInfoFromContext = siteContext?.data;

  // Use override if provided, otherwise use context
  const siteInfo = siteInfoOverride ?? siteInfoFromContext;

  // const [isAtomic] = useFeature('atomic');
  const isAtomic =
    siteInfo &&
    'subtype' in siteInfo &&
    (siteInfo as SiteInfoResponseModelV2).subtype === 'atomic';
  const { brandFromJWT } = useBrandInfo();
  const { id: accountId } = useAccount();

  const brand = brandFromJWT.toLowerCase();
  const {
    id: siteId,
    name: siteName,
    type,
    detected_type: detectedType,
    account_back_ref: accountBackRef,
    account_id: siteInfoAccountId,
  } = siteInfo ?? {};
  const isAiBuilderSite = isAiSite(siteInfo);
  const productInstanceId = accountBackRef || siteInfoAccountId || accountId;

  const isWordPress = checkWordPressType({ type, detected_type: detectedType });
  const isAMDomainPointerFlow =
    brand === 'bluehost' && !isAtomic && isWordPress;

  const baseUrl = window.location.origin;
  const baseRedirectUrl = '/my-account/hosting/details/sites';
  const aiProductRedirectUrl = getAiProductAMRedirectUrl(pathname);
  const redirectUrl =
    aiProductRedirectUrl ??
    (isAiBuilderSite
      ? baseRedirectUrl
      : `${baseRedirectUrl}/${siteId}/domains`);
  const domainControlPanelLink = `/my-account/connect?productInstanceId=${productInstanceId}&siteId=${siteId}&siteName=${siteName}&redirectUrl=${redirectUrl}`;
  const domainFlowUrl = `${baseUrl}${domainControlPanelLink}`;

  return { isAMDomainPointerFlow, domainFlowUrl };
};

export default useAMDomainFlow;
